import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingProductTileSkeleton } from "@faire/retailer-visitor-shared/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
var NUM_TILES = 16;
export var SDUIFilterablePaginatedSectionGridLoadingSkeleton = function() {
    return /*#__PURE__*/ _jsx(Column, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "grid grid-cols-2 md:grid-cols-4 gap-4",
            children: Array.from({
                length: NUM_TILES
            }).map(function(_, index) {
                return /*#__PURE__*/ _jsx(LoadingProductTileSkeleton, {}, index);
            })
        })
    });
};
